import { render, staticRenderFns } from "./ModifyPopup.vue?vue&type=template&id=20eb1a6c"
import script from "./ModifyPopup.vue?vue&type=script&lang=js"
export * from "./ModifyPopup.vue?vue&type=script&lang=js"
import style0 from "./ModifyPopup.vue?vue&type=style&index=0&id=20eb1a6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports